import React from 'react';

import PropTypes from 'prop-types';

import clsx from 'clsx';

import { InfoIcon } from 'reaxl-molecules';

export default function PriceLineItem({ label, value, containerClassName, priceClassName, tooltip, ...rest }) {
    const priceStyling = clsx(
        'iris:font-normal iris:text-base',
        priceClassName,
    );

    const renderTooltip = () => (
        <InfoIcon
            infoText={tooltip}
            className="margin-left-1"
        />
    );

    if (!label && !value) return null;

    return (
        <div
            {...rest}
            className={clsx(
                'iris:grid iris:grid-cols-[1fr_auto] iris:gap-4',
                containerClassName,
            )}
        >
            <div className={priceStyling}>
                {label}
                {tooltip && renderTooltip()}
            </div>
            <div className={clsx('iris:text-right', priceStyling)}>
                {value}
            </div>
        </div>
    );
}

PriceLineItem.propTypes = {
    /**
     * Label for the line item
     */
    label: PropTypes.string,
    /**
     * Value for the line item
     */
    value: PropTypes.string,
    /**
     * Additional class names to apply to the root element
     */
    className: PropTypes.string,
};

PriceLineItem.defaultProps = {
    className: '',
};
